<template>
	<div>
		<div class="vx-row">
			<div class="vx-col xl:w-1/4 lg:w-1/4 w-full mb-6">
				<h1 class="p-3 mb-3">{{$t("DashTaskNumOwn")}}</h1>
				<vx-card>
					<vue-apex-charts type=bar height=590 :options="ownTasksChartConfig" :series="ownTaskDataSeries" />
				</vx-card>
			</div>
			<div class="vx-col xl:w-3/4 lg:w-3/4 w-full mb-6">
				<h1 class="p-3 mb-3">{{$t("DashTaskNum")}}</h1>
				<div class="vx-row mb-6">
					<div class="vx-col xl:w-1/3 lg:w-1/3 md:w-1/2 w-full mb-3">
						<vx-card :title="$t('DashTasksToday')">
							<div class="w-full flex justify-start mb-6" id="dashTasksDay">
								<div class="flex items-center">
									<feather-icon :icon="'ChevronLeftIcon'" svgClasses="w-5 h-5 m-1" @click="taskNumSelectedDay--" class="cursor-pointer bg-primary text-white rounded-full" />
									<span class="mx-3 text-xl font-medium whitespace-no-wrap">{{moment().add(taskNumSelectedDay, 'days').format("DD/MM/YYYY")}}</span>
									<feather-icon v-if="taskNumSelectedDay < 0" :icon="'ChevronRightIcon'" svgClasses="w-5 h-5 m-1" @click="taskNumSelectedDay++" class="cursor-pointer bg-primary text-white rounded-full" />
								</div>
							</div>
							<vue-apex-charts type=bar height=500 :options="getTaskChartConfig(taskDataCategories)" :series="taskDataToday" />
						</vx-card>
					</div>
					<div class="vx-col xl:w-1/3 lg:w-1/3 md:w-1/2 w-full mb-3">
						<vx-card :title="$t('DashTasksThisWeek')">
							<div class="w-full flex justify-start mb-6" id="dashTasksWeek">
								<div class="flex items-center">
									<feather-icon :icon="'ChevronLeftIcon'" svgClasses="w-5 h-5 m-1" @click="taskNumSelectedWeek--" class="cursor-pointer bg-primary text-white rounded-full" />
									<span class="mx-3 text-xl font-medium whitespace-no-wrap">{{moment().add(taskNumSelectedWeek, 'week').startOf('week').add(1, "days").format("DD/MM/YY")}} - {{moment().add(taskNumSelectedWeek, 'week').endOf('week').add(1, "days").format("DD/MM/YY")}}</span>
									<feather-icon v-if="taskNumSelectedWeek < 0" :icon="'ChevronRightIcon'" svgClasses="w-5 h-5 m-1" @click="taskNumSelectedWeek++" class="cursor-pointer bg-primary text-white rounded-full" />
								</div>
							</div>
							<vue-apex-charts type=bar height=500 :options="getTaskChartConfig(taskDataCategories)" :series="taskDataThisWeek" />
						</vx-card>
					</div>
					<div class="vx-col xl:w-1/3 lg:w-1/3 md:w-1/2 w-full mb-3">
						<vx-card :title="$t('DashTasksThisMonth')">
							<div class="w-full flex justify-start mb-6" id="dashTasksMonth">
								<div class="flex items-center">
									<feather-icon :icon="'ChevronLeftIcon'" svgClasses="w-5 h-5 m-1" @click="taskNumSelectedMonth--" class="cursor-pointer bg-primary text-white rounded-full" />
									<span class="mx-3 text-xl font-medium whitespace-no-wrap">{{moment().add(taskNumSelectedMonth, 'month').format("MM/YYYY")}}</span>
									<feather-icon v-if="taskNumSelectedMonth < 0" :icon="'ChevronRightIcon'" svgClasses="w-5 h-5 m-1" @click="taskNumSelectedMonth++" class="cursor-pointer bg-primary text-white rounded-full" />
								</div>
							</div>
							<vue-apex-charts type=bar height=500 :options="getTaskChartConfig(taskDataCategories)" :series="taskDataThisMonth" />
						</vx-card>
					</div>
				</div>
			</div>
		</div>
		<vs-divider/>
		<h1 class="p-3 mb-3">{{$t("DashTaskTime")}}</h1>
		<div class="vx-row mb-6">
			<div class="vx-col xl:w-1/3 lg:w-1/3 md:w-1/2 w-full mb-3 mb-base">
				<vx-card :title="$t('DashTimeToday')">
					<div class="w-full flex justify-start mb-6" id="dashTaskTimesDay">
						<div class="flex items-center">
							<feather-icon :icon="'ChevronLeftIcon'" svgClasses="w-5 h-5 m-1" @click="workTimeSelectedDay--" class="cursor-pointer bg-primary text-white rounded-full" />
							<span class="mx-3 text-xl font-medium whitespace-no-wrap">{{moment().add(workTimeSelectedDay, 'days').format("DD/MM/YYYY")}}</span>
							<feather-icon v-if="workTimeSelectedDay < 0" :icon="'ChevronRightIcon'" svgClasses="w-5 h-5 m-1" @click="workTimeSelectedDay++" class="cursor-pointer bg-primary text-white rounded-full" />
						</div>
					</div>
					<vue-apex-charts type=bar height=500 :options="getTaskChartConfig(timeDataCategories)" :series="taskTimeDataToday" />
				</vx-card>
			</div>
			<div class="vx-col xl:w-1/3 lg:w-1/3 md:w-1/2 w-full mb-3 mb-base">
				<vx-card :title="$t('DashTimeThisWeek')">
					<div class="w-full flex justify-start mb-6" id="dashTaskTimesWeek">
						<div class="flex items-center">
							<feather-icon :icon="'ChevronLeftIcon'" svgClasses="w-5 h-5 m-1" @click="workTimeSelectedWeek--" class="cursor-pointer bg-primary text-white rounded-full" />
							<span class="mx-3 text-xl font-medium whitespace-no-wrap">{{moment().add(workTimeSelectedWeek, 'week').startOf('week').add(1, "days").format("DD/MM/YY")}} - {{moment().add(workTimeSelectedWeek, 'week').endOf('week').add(1, "days").format("DD/MM/YY")}}</span>
							<feather-icon v-if="workTimeSelectedWeek < 0" :icon="'ChevronRightIcon'" svgClasses="w-5 h-5 m-1" @click="workTimeSelectedWeek++" class="cursor-pointer bg-primary text-white rounded-full" />
						</div>
					</div>
					<vue-apex-charts type=bar height=500 :options="getTaskChartConfig(timeDataCategories)" :series="taskTimeDataThisWeek" />
				</vx-card>
			</div>
			<div class="vx-col xl:w-1/3 lg:w-1/3 md:w-1/2 w-full mb-3 mb-base">
				<vx-card :title="$t('DashTimeThisMonth')">
					<div class="w-full flex justify-start mb-6" id="dashTaskTimesMonth">
						<div class="flex items-center">
							<feather-icon :icon="'ChevronLeftIcon'" svgClasses="w-5 h-5 m-1" @click="workTimeSelectedMonth--" class="cursor-pointer bg-primary text-white rounded-full" />
							<span class="mx-3 text-xl font-medium whitespace-no-wrap">{{moment().add(workTimeSelectedMonth, 'month').format("MM/YYYY")}}</span>
							<feather-icon v-if="workTimeSelectedMonth < 0" :icon="'ChevronRightIcon'" svgClasses="w-5 h-5 m-1" @click="workTimeSelectedMonth++" class="cursor-pointer bg-primary text-white rounded-full" />
						</div>
					</div>
					<vue-apex-charts type=bar height=500 :options="getTaskChartConfig(timeDataCategories)" :series="taskTimeDataThisMonth" />
				</vx-card>
			</div>
		</div>
	</div>
</template>
<script>

	import VueApexCharts from 'vue-apexcharts'

	export default {
		components: {
			VueApexCharts
		},
		data() {
			return {
				taskData: null,
				timeData: null,
				ownTaskData: null,

				taskNumSelectedDay: 0,
				taskNumSelectedWeek: 0,
				taskNumSelectedMonth: 0,

				workTimeSelectedDay: 0,
				workTimeSelectedWeek: 0,
				workTimeSelectedMonth: 0,

				taskDataCategories: [this.$t('TasksAdded'), this.$t('TasksFinished')],
				timeDataCategories: [this.$t('DashTimeInvoiced'), this.$t('DashTimeNonInvoiced'), this.$t('DashTimeOnCompany')],

				ownTasksChartConfig: {
					grid: {
						borderColor: '#ebebeb',
						padding: {
							left: 0,
							right: 0
						}
					},
					dataLabels: {
						enabled: false
					},
					chart: {
						stacked: false,
						type: 'bar',
					},
					colors: ['#2ecc71', '#3498db', '#f1c40f', '#9b59b6', '#e74c3c'],
					plotOptions: {
						bar: {
							columnWidth: '70%',
						}
					},
					xaxis: {
						axisTicks: {
							show: true,
						},
						categories: [" "],
						axisBorder: {
							show: false,
						},
					},
					yaxis: {
						labels: {
							style: {
								cssClass: 'text-grey fill-current',
							}
						}
					},
					tooltip: {
						x: { show: false },
					},
					legend: {
						height: 80,
						offsetY: -30,
						horizontalAlign: "left",
						itemMargin: {
							horizontal: 5,
							vertical: 10
						}
					}
				}

			}
		},
		computed: {
			taskDataToday() {
				if(!this.taskData) return [];
				return this.calculateTaskNumSeries(this.taskData.today);
			},
			taskDataThisWeek() {
				if(!this.taskData) return [];
				return this.calculateTaskNumSeries(this.taskData.this_week);
			},
			taskDataThisMonth() {
				if(!this.taskData) return [];
				return this.calculateTaskNumSeries(this.taskData.this_month);
			},

			taskTimeDataToday() {
				if(!this.timeData) return [];
				return this.calculateTaskTimeSeries(this.timeData.today);
			},
			taskTimeDataThisWeek() {
				if(!this.timeData) return [];
				return this.calculateTaskTimeSeries(this.timeData.this_week);
			},
			taskTimeDataThisMonth() {
				if(!this.timeData) return [];
				return this.calculateTaskTimeSeries(this.timeData.this_month);
			},
			ownTaskDataSeries() {

				if(!this.ownTaskData) return[];
				let data = [];

				data.push({name: this.$t('DashOwnTasksOpen'), data: [this.ownTaskData.open]});
				data.push({name: this.$t('DashOwnTasksInConfirmation'), data: [this.ownTaskData.in_confirmation]});
				data.push({name: this.$t('DashOwnTasksDeadlineToday'), data: [this.ownTaskData.deadline_today]});
				data.push({name: this.$t('DashOwnTasksDeadlineNext7Days'), data: [this.ownTaskData.deadline_next_7_days]});
				data.push({name: this.$t('DashOwnTasksOverDeadline'), data: [this.ownTaskData.over_deadline]});


				return data;

			}
		},
		methods: {
			getTaskChartConfig(categories) {
				return {
					grid: {
						borderColor: '#ebebeb',
						padding: {
							left: 0,
							right: 0
						}
					},
					dataLabels: {
						enabled: false
					},
					chart: {
						stacked: true,
						type: 'bar',
					},
					colors: ['#9b59b6', '#3498db', '#2ecc71', '#f1c40f', '#e74c3c'],
					plotOptions: {
						bar: {
							columnWidth: '70%',
						}
					},
					xaxis: {
						axisTicks: {
							show: true,
						},
						categories: categories,
						axisBorder: {
							show: false,
						},
					},
					yaxis: {
						labels: {
							style: {
								cssClass: 'text-grey fill-current',
							}
						}
					},
					tooltip: {
						x: { show: false },
					},
				}
			},
			updateDashboardTasks() {
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/tasks')
						.then(function (response) {
							thisIns.taskData = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			updateDashboardTime() {
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/work_time')
						.then(function (response) {
							thisIns.timeData = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			updateDashboardOwnTasks() {
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/own_tasks')
						.then(function (response) {
							thisIns.ownTaskData = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			calculateTaskNumSeries(inData) {

				let data = [];

				let tasks = {};
				tasks[1] = [0, 0];
				tasks[2] = [0, 0];
				tasks[3] = [0, 0];
				tasks[4] = [0, 0];
				tasks[5] = [0, 0];

				for(let x = 0; x < inData.length; x++) {

					tasks[inData[x].priority] = [inData[x].added, inData[x].finished];

				}

				data.push({name: '1', data: tasks[1]});
				data.push({name: '2', data: tasks[2]});
				data.push({name: '3', data: tasks[3]});
				data.push({name: '4', data: tasks[4]});
				data.push({name: '5', data: tasks[5]});

				return data;

			},
			calculateTaskTimeSeries(inData) {
				let data = [];

				let tasks = {};
				tasks[1] = [0, 0, 0];
				tasks[2] = [0, 0, 0];
				tasks[3] = [0, 0, 0];
				tasks[4] = [0, 0, 0];
				tasks[5] = [0, 0, 0];

				for(let x = 0; x < inData.length; x++) {

					tasks[inData[x].priority] = [inData[x].worked_time, inData[x].non_invoiced_time, inData[x].local_time];

				}

				data.push({name: '1', data: tasks[1]});
				data.push({name: '2', data: tasks[2]});
				data.push({name: '3', data: tasks[3]});
				data.push({name: '4', data: tasks[4]});
				data.push({name: '5', data: tasks[5]});

				return data;
			}

		},
		watch: {
			taskNumSelectedDay() {
				this.$vs.loading({
					container: '#dashTasksDay',
					scale: 1
				});
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/tasks/day/' + this.taskNumSelectedDay)
						.then(function (response) {
							thisIns.taskData.today = response.data;
							thisIns.$vs.loading.close('#dashTasksDay > .con-vs-loading');
						})
						.catch(function (error) {
							thisIns.$vs.loading.close('#dashTasksDay > .con-vs-loading');
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			taskNumSelectedWeek() {
				this.$vs.loading({
					container: '#dashTasksWeek',
					scale: 1
				});
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/tasks/week/' + this.taskNumSelectedWeek)
						.then(function (response) {
							thisIns.taskData.this_week = response.data;
							thisIns.$vs.loading.close('#dashTasksWeek > .con-vs-loading');
						})
						.catch(function (error) {
							thisIns.$vs.loading.close('#dashTasksWeek > .con-vs-loading');
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			taskNumSelectedMonth() {
				this.$vs.loading({
					container: '#dashTasksMonth',
					scale: 1
				});
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/tasks/month/' + this.taskNumSelectedMonth)
						.then(function (response) {
							thisIns.taskData.this_month = response.data;
							thisIns.$vs.loading.close('#dashTasksMonth > .con-vs-loading');
						})
						.catch(function (error) {
							thisIns.$vs.loading.close('#dashTasksMonth > .con-vs-loading');
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			workTimeSelectedDay() {
				this.$vs.loading({
					container: '#dashTaskTimesDay',
					scale: 1
				});
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/work_time/day/' + this.workTimeSelectedDay)
						.then(function (response) {
							thisIns.timeData.today = response.data;
							thisIns.$vs.loading.close('#dashTaskTimesDay > .con-vs-loading');
						})
						.catch(function (error) {
							thisIns.$vs.loading.close('#dashTaskTimesDay > .con-vs-loading');
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			workTimeSelectedWeek() {
				this.$vs.loading({
					container: '#dashTaskTimesWeek',
					scale: 1
				});
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/work_time/week/' + this.workTimeSelectedWeek)
						.then(function (response) {
							thisIns.timeData.this_week = response.data;
							thisIns.$vs.loading.close('#dashTaskTimesWeek > .con-vs-loading');
						})
						.catch(function (error) {
							thisIns.$vs.loading.close('#dashTaskTimesWeek > .con-vs-loading');
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			workTimeSelectedMonth() {
				this.$vs.loading({
					container: '#dashTaskTimesMonth',
					scale: 1
				});
				const thisIns = this;
				this.$http.get('/api/v1/dashboard/work_time/month/' + this.workTimeSelectedMonth)
						.then(function (response) {
							thisIns.timeData.this_month = response.data;
							thisIns.$vs.loading.close('#dashTaskTimesMonth > .con-vs-loading');
						})
						.catch(function (error) {
							thisIns.$vs.loading.close('#dashTaskTimesMonth > .con-vs-loading');
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			}
		},
		created() {
			this.updateDashboardTasks();
			this.updateDashboardTime();
			this.updateDashboardOwnTasks();
		},
	}
</script>
